import { Pilot } from '@/types/utm/pilot.types';

export function getPilotName(pilot?: Pilot | null) {
  if (!pilot) {
    return '';
  }
  const lastName = pilot.lastName ? ` ${pilot.lastName}` : '';
  return `${pilot.firstName}${lastName}`;
}
